import React from "react";

const NoticeOfParticularsOfVariation = () => {
  return <div>NoticeOfParticularsOfVariation</div>;
};

export default NoticeOfParticularsOfVariation;
